import styled from 'styled-components';

import { OnboardingPage } from '../../../../components/Page';

export const ScreenAiSayStyles = styled(OnboardingPage)`
  .local-title {
    margin: 0 0 8px;
  }

  ion-content {
    &::part(scroll) {
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 26px 0;
    }

    .image-container {
      position: absolute;
      bottom: 70px;
      width: 290px;
      aspect-ratio: 1.62;
    }
  }
`;
